<template>
    <div>
        <div>
            <ul>
                <li v-for="file in files" :key="file.Id" @click="download(file.Url,file.FileName)">{{file.FileName}}</li>
            </ul>
        </div>
    </div>
</template>

<style lang="scss" scoped>
ul {
    margin: 0;
    padding: 0
}

ul>li {
    list-style-type: none;
    cursor: pointer;
    color:#006ab4;
}

li:hover {
    background-color: aliceblue
}
</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            files: {},
            id: 0
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.id = this.data.Id;
                this.files = this.data.Files

            }
        },
       download(url, fileName) {
            var link = document.createElement("a");
            link.target="_blank";
            link.href = url;
            link.download = fileName;
            link.click();
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/filesCell.vue